import React from "react";

const sizeClasses = {
  sm: "h-6 w-6 border-2",
  md: "h-10 w-10 border-2",
  lg: "h-12 w-12 border-4",
};

/**
 * Reusable loading component.
 * @param {string} [variant="inline"] - "inline" for content-area loading, "overlay" for full-screen
 * @param {string} [text] - Optional message below the spinner
 * @param {string} [size="md"] - Spinner size: "sm" | "md" | "lg"
 */
const Loading = ({ variant = "inline", text, size = "md" }) => {
  const spinner = (
    <div
      className={`${sizeClasses[size] || sizeClasses.md} animate-spin rounded-full border-brand-500 border-t-transparent`}
      role="status"
      aria-label="Loading"
    />
  );

  if (variant === "overlay") {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
        <div className="flex flex-col items-center rounded-xl bg-white p-6 shadow-xl dark:bg-navy-800">
          {spinner}
          {text && (
            <p className="mt-4 text-sm font-medium text-navy-700 dark:text-white">
              {text}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-8">
      {spinner}
      {text && (
        <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">{text}</p>
      )}
    </div>
  );
};

export default Loading;
